import { autoinject } from "aurelia-framework";

@autoinject
export class IconsStorage {

    private _promise: Promise<void>;
    public icons: { name: string, displayName: string, code: string }[] = [];

    constructor() {
        this.getIcons();
    }

    getIcons(): Promise<void> {
        if (!this._promise) {
            this._promise = new Promise<void>((resolve) => {
                fetch('/views/components/icon-picker/icon-codepoints.txt')
                    .then(response => response.text())
                    .then(data => data.split('\n'))
                    .then(namesAndCodes => namesAndCodes.map(nameAndCode => {
                        const parts = nameAndCode.split(' ');
                        return {
                            name: parts[0],
                            displayName: parts[0].split('_').join(' '),
                            code: parts[1]
                        };
                    }))
                    .then((icons) => {
                        this.icons = icons;
                        resolve();
                    });
            })
        }
        return this._promise;
    }

}
